import { CacheableDataObject } from './CacheableDataObject';


export default class MatchTeamReport extends CacheableDataObject {
	reportedSomething() {
		return !!(this.hasReportValueSet() || this.hasDisputeMessage());
	}

	hasReportValueSet() {
		return !!(this.reported_win || this.reported_loss || this.reported_dispute || this.reported_cancel);
	}

	hasDisputeMessage() {
		return this.dispute_message !== null && this.dispute_message !== undefined;
	}
}
MatchTeamReport.prototype.dataLocationParsers = {};